<ng-content select="cs-label"></ng-content>
@if (shouldShowInputLabel) {
  <cs-label>{{ label }}</cs-label>
}
<ng-content></ng-content>
